export default "__VITE_ASSET__B4Zbzzen__"